// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const ArrowUUpLeft = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M21.75 13.5a6.007 6.007 0 0 1-6 6H7.5a.75.75 0 0 1 0-1.5h8.25a4.5 4.5 0 0 0 0-9H4.81l3.22 3.22a.75.75 0 0 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.81 7.5h10.94a6.007 6.007 0 0 1 6 6Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'ArrowUUpLeft',
})

export const ArrowUUpRight = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M15.97 12.22 19.19 9H8.25a4.5 4.5 0 0 0 0 9h8.25a.75.75 0 0 1 0 1.5H8.25a6 6 0 0 1 0-12h10.94l-3.22-3.22a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'ArrowUUpRight',
})
